// extracted by mini-css-extract-plugin
module.exports = {"m--card":"DuplicateCard_m--card__E_h0N","m--card-selected":"DuplicateCard_m--card-selected__g5aWS"};